import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { debounce } from 'lodash';
import {
  getSubVendor,
  patchUpdateSubVendor,
  postAddSubVendor,
} from 'redux/actions/UserSubVendor';
import {
  getVendoruser,
  patchUpdateVendor,
  postAddVendor,
} from 'redux/actions/UserVendor';
import {
  getDriver,
  patchUpdateDriver,
  postAddDriver,
} from 'redux/actions/UserDriver';
import {
  getVehicle,
  patchUpdateVehicle,
  postAddVehicle,
} from 'redux/actions/UserVehicle';
import { getCar } from 'redux/actions/UserCar';
import { getOnBoardCompliance } from 'redux/actions/UserCompliance';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import { fetchSupplierRole } from 'redux/actions/RolesAndPermissionsAction';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import Breadcrumb from 'pages/vendor/BreadCrumb';
import {
  driverDialogData,
  vendorDialogData,
  subVendorDialogData,
  vehicleDialogData,
  filterStatusVehicle,
  filterStatusData
} from 'pages/vendor/VendorBreadCrumbData';
import TabVendor from './TabVendor';

function ViewVendor() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams()

  const id = searchParams?.get('id');
  const companyId = searchParams?.get('companyId');
  const cityLocation = searchParams?.get('cityLocation');
  const name = searchParams?.get('name');
  const cityLocationId = searchParams?.get('cityLocationId');
  const tabs = searchParams?.get('tabType');
  const paramsStatus = searchParams?.get('filterStatus');
  const paramsSearch = searchParams?.get('search');
  const paramsPage = searchParams?.get('page');
  const paramsPageSize = searchParams?.get('pageSize');
  let paramsList = {};

  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  const navigate = useNavigate();
  const subVendorData = useSelector(
    (state) => state?.userSubVendor?.userSubVendor?.data
  );
  const driverData = useSelector(
    (state) => state?.userDriver?.userDriver?.data
  );
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const vendorData = useSelector(
    (state) => state?.userVendor?.userVendor?.data?.body[0]
  );
  const vendorUserData = useSelector(
    (state) => state?.userVendorUser?.userVendorUser?.data
  );
  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );
  const loadersubVendor = useSelector((state) => state?.userSubVendor?.loading);
  const loaderDriver = useSelector((state) => state?.userDriver?.loading);
  const loaderVehicle = useSelector((state) => state?.userVehicle?.loading);
  const loaderUser = useSelector((state) => state?.userVendorUser?.loading);
  const loader = useSelector((state) => state?.userVendor?.loading);
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const supplierRole = useSelector((state) => state?.getSupplierRole?.roles);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });
  const locationList = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const locationOption =locationList?.length > 0 && locationList?.map((val, idx) => {
    return { value: val?.id, label: val?.name };
  });

  const roleOption =supplierRole?.length > 0 && supplierRole?.map((val, idx) => {
    return { value: val?.role, label: val?.roleName };
  });

  const defaultSubVendor = {
    name: name,
  };
  const defaultUser = {
    city: cityLocation,
  };
  const [formData, setFormData] = useState(
    tabs === '2'
      ? driverDialogData
      : tabs === '3'
      ? vehicleDialogData(carOption?.length > 0 ? carOption : [])
      :tabs === '4'
      ? vendorDialogData(roleOption)
      : subVendorDialogData
  );
  const [tableData, setTableData] = useState(
    tabs == '2'
      ? driverData
      : tabs === '3'
      ? vehicleData
      : tabs === '4'
      ? vendorUserData
      : subVendorData || {}
  );
  const [type, setType] = useState('Sub-Vendor');
  const [buttonText, setButtonText] = useState('+ Sub-Vendor');
  const [value, setValue] = useState(tabs ? tabs : '2');
  const [open, setOpen] = useState(false);
  const [iconType, setIconType] = useState('Edit');
  const [iconId, setIconId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState(paramsStatus ? paramsStatus?.split(',') : '');
  const [page, setPage] = useState( parseInt(paramsPage) || 0);
  const [rowsPerPage, setRowsPerPage] = useState(paramsPageSize || 10);
  const [filterLocation, setFilterLocation] = useState('');
  const [search, setSearch] = useState(paramsSearch || '');
  let filterData = {
    id: id,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: 'vendor',
    search: search,
  };
  let filterVehicleData = {
    id: companyId,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: 'vendor',
    search: search,
  };

  const role = {
    role:2,
    businessType:0,
  };

  useEffect(() => {
    dispatch(getCar({loader:true}));
    dispatch(getServiceCity());
    dispatch(fetchSupplierRole(role))
    if (tabs === '1') {
      setButtonText('+ Sub-Vendor');
      setType('Sub-Vendor');
      setFormData(subVendorDialogData);
      dispatch(getSubVendor(filterData));
      setTableData(subVendorData);
    } else if (tabs === '2') {
      setButtonText('+ Driver');
      setType('Driver');
      setFormData(driverDialogData);
      dispatch(getDriver(filterData));
      setTableData(driverData);
    } else if (tabs === '3') {
      setButtonText('+ Vehicle');
      setType('Vehicle');
      setFormData(vehicleDialogData(carOption?.length > 0 ? carOption : []));
      dispatch(getVehicle({ ...filterVehicleData}));
      setTableData(vehicleData);
    } else if (tabs === '4') {
      setButtonText('+ User');
      setFormData(vendorDialogData(roleOption));
      dispatch(getVendoruser(filterData));
      setTableData(vendorUserData);
      setType('User');
    } else {
      setButtonText('');
    }
  }, []);

  useEffect(() => {
    if (tabs === '3' && !carList?.length) {
      setFormData(vehicleDialogData(carOption?.length > 0 ? carOption : []));
    } else if(tabs === '4'){
      setFormData(vendorDialogData(roleOption?.length > 0 ? roleOption: []));
    }
  }, [carList,supplierRole]);

  useEffect(() => {
    if (type === 'Driver') {
      setTableData(driverData);
    } else if (type === 'Vehicle') {
      setTableData(vehicleData);
    } else if (type === 'User') {
      setTableData(vendorUserData);
    } else {
      setTableData(subVendorData);
    }
  }, [driverData, subVendorData, vehicleData, vendorUserData]);

  const handleTabChange = (newValue) => {
    setSearchParams({...paramsList, tabType:newValue, search:'', filterStatus:'', page:0, pageSize:10})
    setValue(newValue);
    setPage(0);
    setStatus([]);
    setSearch('')
    if (newValue === '1') {
      setButtonText('+ Sub-Vendor');
      setType('Sub-Vendor');
      setFormData(subVendorDialogData);
      dispatch(getSubVendor({...filterData,search:'',status: '',page:0}));
      setTableData(subVendorData);
    } else if (newValue === '2') {
      setButtonText('+ Driver');
      setType('Driver');
      setFormData(driverDialogData);
      dispatch(getDriver({...filterData,search:'',status: '',page:0}));
      setTableData(driverData);
    } else if (newValue === '3') {
      setButtonText('+ Vehicle');
      setType('Vehicle');
      setFormData(vehicleDialogData(carOption?.length > 0 ? carOption : []));
      dispatch(getVehicle({ ...filterVehicleData, status: '',search:'',page:0}));
      setTableData(vehicleData);
    } else if (newValue === '4') {
      setButtonText('+ User');
      setFormData(vendorDialogData(roleOption));
      dispatch(getVendoruser({...filterData,search:'',page:0}));
      setTableData(vendorUserData);
      setType('User');
    } else {
      setButtonText('');
    }
  };
  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
    if (type === 'Driver') {
      const data = {
        mobile: val.number,
        firstName: val.driverName,
        lastName: '',
        altmobile: val.mobile,
        DOB: val.birthday,
        permanentaddress: val.permanentaddress,
        currentaddress: val.currentaddress,
        covid: val.covid,
        email: val.email,
        countryCode: code,
        parentId: id,
        vendorId: id,
        companyName: val.driverName+ val.number,
        isB2B: 'true',
      };
      dispatch(postAddDriver(data));
    } else if (type === 'Vehicle') {
      const allData = {
        ...val,
        carType: 'COC',
        seating: parseInt(val?.seating),
        id: companyId,
        type: 'vendor',
        avtar: selectedImage,
      };
      let formData = new FormData();
      Object.keys(allData).map((val) => {
        formData.append(val, allData[val]);
      });
      dispatch(postAddVehicle(formData));
    } else if (type === 'User') {
      const data = {
        mobile: val.number,
        firstName: val?.vendorName.trim(),
        lastName: '',
        email: val.email,
        countryCode: code,
        companyName: val?.vendorName.trim(),
        location: cityLocationId,
        id: id,
        role: val?.role,
        roleType: 2,
      };
      dispatch(postAddVendor(data));
    } else {
      const data = {
        mobile: val.number,
        firstName: '',
        lastName: '',
        email: val.email,
        countryCode: code,
        vendorId: id,
        companyName: val.vendorName,
        isB2B: 'true',
      };
      dispatch(postAddSubVendor(data));
    }
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const onClickTableRow = (navigate, val) => {
    if (value === '1') {
      navigate('/citymanager/subvendor', {
        state: {
          subVendorId: val?.id,
          status: val?.status,
          name: val?.companyName,
          companyId: val?.companyId,
          cityLocation: val?.location,
        },
      });
    } else if (value === '2') {
      navigate('/citymanager/driver', {
        state: {
          id: val?.id,
          status: val?.status,
          name: val?.name,
          tabName: 'driver',
        },
      });
    } else if (value === '3') {
      navigate('/citymanager/vehicle', {
        state: { vehicleId: val?.id, status: val?.status, name: val?.carModel },
      });
    }
    // }
  };

  const createProfileData = (data, iconType, companyId, page, rowsPerPage, search, status) => {
    return {
      subVendorId: data.id,
      driverId: data.id,
      page: page,
      pageSize: rowsPerPage,
      search: search,
      data: {
        status: status,
        isB2B: 'true',
      },
    };
  };
  
  const handleProfileUpdate = (data, iconType, companyId, page, rowsPerPage, search, status) => {
    const profileData = createProfileData(data, iconType, companyId, page, rowsPerPage, search, status);
    if (type === 'Sub-Vendor') {
      dispatch(patchUpdateSubVendor({ ...profileData, id: companyId }));
    } else if (type === 'Driver') {
      dispatch(patchUpdateDriver({ ...profileData, parentId: companyId }));
    }
  };
  

  const onClickMoreIcon = (data, iconType) => {
    if (type === 'Sub-Vendor' || type === 'Driver') {
      const value = {
        vendorName: data?.companyName,
        driverName: data?.name,
        email: data?.email,
        number: data?.mobile,
        address: data?.location,
        name: data?.vendorName,
      };
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === 'Delete') {
      } else if (iconType === 'Edit') {
        setIconType(iconType);
        setOpen(true);
      } else if (iconType === 'Deactivate') {
    handleProfileUpdate(data, iconType, companyId, page, rowsPerPage, search, 'InActive');
  } else if (iconType === 'Upload Compliance' && type === 'Driver'){
    setIconType(iconType);
    setOpen(true);
    const profileData = { 
      driverId: data.id,
      type: 'driverRegistration'
    };
    setShowOtherComponent(true);
    dispatch(getOnBoardCompliance(profileData));
  }
  else if (iconType === 'Activate') {
    handleProfileUpdate(data, iconType, companyId, page, rowsPerPage, search, 'Active');
  } else if (iconType === 'Block') {
    handleProfileUpdate(data, iconType, companyId, page, rowsPerPage, search, 'Blocked');
  } else if (iconType === 'Unblock') {
    handleProfileUpdate(data, iconType, companyId, page, rowsPerPage, search, 'Active');
  }
    } else if (type === 'Vehicle') {
      const value = data;
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === 'Delete') {
      } else if (iconType === 'Edit' || iconType === 'Upload Compliance') {
        setIconType(iconType);
        setOpen(true);
      } if (iconType === 'Upload Compliance') {
        const profileData = {
          page:page,
          pageSize:rowsPerPage,
          vehicleId: data.id,
          search:search,
          type: 'vehicleRegistration',
        };
        setShowOtherComponent(true);
        dispatch(getOnBoardCompliance(profileData));
      } else if (iconType === 'Activate'|| iconType === 'Deactivate') {
        const isApproved = iconType === "Activate" ? "Active" : "InActive";
        const profileData = {
          vehicleId: data.id,
          page:page,
          pageSize:rowsPerPage,
          search:search,
          type: 'vendor',
          data: {
            isApproved: isApproved,
          },
        };
        dispatch(patchUpdateVehicle({ ...profileData, parentId: companyId }));
      }
    } else if (type === 'User') {
      const value = {
        vendorName: data?.companyName.trim(),
        email: data?.email,
        number: data?.mobile,
        city: data?.location,
      };
      setDefaultValue(value);
      setIconId(data.id);
      if (type === 'Delete') {
      } else if (type === 'Edit') {
        setType(type);
        setIconType(iconType);
        setOpen(true);
      } else if (type === 'Deactivate') {
        const profileData = {
          vendorId: data.id,
          data: {
            status: 'InActive',
          },
        };
        dispatch(patchUpdateVendor(profileData));
      } else if (type === 'Activate') {
        const profileData = {
          vendorId: data.id,
          data: {
            status: 'Active',
          },
        };
        dispatch(patchUpdateVendor(profileData));
      } else if (type === 'Block') {
        const profileData = {
          vendorId: data.id,
          data: {
            status: 'Blocked',
          },
        };
        dispatch(patchUpdateVendor(profileData));
      } else if (type === 'Unblock') {
        const profileData = {
          vendorId: data.id,
          data: {
            status: 'Active',
          },
        };
        dispatch(patchUpdateVendor(profileData));
      }
    }
  };

  const onDialog = (data, code, val) => {
    if (type === 'Sub-Vendor') {
      const profileData = {
        subVendorId: iconId,
        id: id,
        data: {
          firstName: data?.vendorName,
          lastName: '',
          email: data?.email,
          countryCode: '+91',
          mobile: data?.number,
          companyName: data?.vendorName,
          location: data?.address,
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (type === 'Driver') {
      const profileData = {
        driverId: iconId,
        parentId: id,
        data: {
          firstName: data?.driverName,
          lastName: '',
          email: data?.email,
          countryCode: '+91',
          mobile: data?.number,
          companyName: '',
          location: data?.address,
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    } else if (type === 'Vehicle') {
      const allData = {
        ...data,
        carType: 'COC',
        seating: parseInt(data?.seating),
        id: iconId,
        parentId: companyId,
        type: 'vendor',
        avtar: selectedImage,
      };
      let formData = new FormData();
      Object.keys(allData).map((val) => {
        formData.append(val, allData[val]);
      });
      dispatch(patchUpdateVehicle(formData));
    } else if (type === 'User') {
      const profileData = {
        vendorId: id,
        data: {
          firstName: data?.vendorName,
          lastName: '',
          email: data?.email,
          countryCode: code,
          mobile: data?.number,
          companyName: data?.vendorName.trim(),
          location: data?.location,
        },
      };
      dispatch(patchUpdateVendor(profileData));
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setShowOtherComponent(false);
  };

  const handleChangePage = (event, newPage) => {
    setSearchParams({...paramsList, page:newPage})
    setPage(newPage);
    if (value === '1') {
      dispatch(getSubVendor({ ...filterData, page: newPage }));
    } else if (value === '2') {
      dispatch(getDriver({ ...filterData, page: newPage }));
    } else if (value === '3') {
      dispatch(getVehicle({ ...filterVehicleData, page: newPage }));
    } else if (value === '4') {
      dispatch(getVendoruser({ ...filterData, page: newPage }));
    } 
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({...paramsList, page:0, pageSize:parseInt(event.target.value)})
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    if (value === '1') {
      dispatch(
        getSubVendor({
          ...filterData,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    } else if (value === '2') {
      dispatch(
        getDriver({
          ...filterData,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    } else if (value === '3') {
      dispatch(
        getVehicle({
          ...filterVehicleData,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    }else if (value === '4') {
      dispatch(
        getVendoruser({
          ...filterData,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    }
  };

  const onFilterChange = (val) => {
    setPage(0);
    const defaultStatus = [
      'Active',
      'InActive',
      'Blocked',
      'Pending',
      'Rejected',
    ];


    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });
    setSearchParams({...paramsList, page:0, filterStatus:val?.toString()})

    setStatus(val);

    if (value === '1') {
      filterData = {
        ...filterData,
        status: val?.toString(),
        page: 0,
      };
      dispatch(getSubVendor(filterData));
    } else if (value === '2') {
      filterData = {
        ...filterData,
        status: val?.toString(),
        page: 0,
      };
      dispatch(getDriver(filterData));
    } else if (value === '3') {
      const vehicleFilterData = {
        ...filterVehicleData,
        status: val?.toString(),
        page: 0,
      };
      dispatch(getVehicle(vehicleFilterData));
    }
  };

  const onRestFilter = () => {
    setSearchParams({...paramsList, page:0, filterStatus:''})
    setStatus('');
    setPage(0);
    if (value === '1') {
      filterData = {
        ...filterData,
        status: '',
        page: 0,
      };
      dispatch(getSubVendor(filterData));
    } else if (value === '2') {
      filterData = {
        ...filterData,
        status: '',
        page: 0,
      };
      dispatch(getDriver(filterData));
    } else if (value === '3') {
      filterData = {
        ...filterVehicleData,
        status: '',
        page: 0,
      };
      dispatch(getVehicle(filterData));
    }
  };

  const onSearch = debounce((e) => {
    setSearchParams({...paramsList, page:0, search:e})
    setSearch(e);
    setPage(0);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
    };
    if (value == '1') {
      dispatch(getSubVendor(searchFilterData));
    } else if (value == '2') {
      dispatch(getDriver(searchFilterData));
    } else if (value == '3') {
      dispatch(getVehicle(searchFilterData));
    } else if (value == '4') {
      dispatch(getVendoruser(searchFilterData));
    }
  }, 1000);

  const closeUploadCompliance = () => {
    setShowOtherComponent(false);
  };

  return (
    <div>
      <Breadcrumb
        buttonText={buttonText}
        formData={formData}
        type={type}
        onSubmittBtn={onSubmit}
        setSelectedImage={selectedImage}
        name={cityLocation}
        defaultValues={type === 'User' ? defaultUser : defaultSubVendor}
        onImageChange={onImageChange}
        showOtherComponent={showOtherComponent}
        closeUploadCompliance={closeUploadCompliance}
      />
      <TabVendor
        defaultStatus={status}
        onTabChange={handleTabChange}
        TableData={tableData}
        onClickTable={onClickTableRow}
        value={value}
        onClickMoreIcon={onClickMoreIcon}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        filterdata={type === 'Vehicle' ? filterStatusVehicle : filterStatusData}
        onSearch={onSearch}
        loaderDriver={loaderDriver}
        loaderVehicle={loaderVehicle}
        loadersubVendor={loadersubVendor}
        loaderUser={loaderUser}
        search={search}
      />

      {open && type !== 'Vehicle' && type !== 'Driver' ? (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          type={'Edit ' + type + ' '}
          selectType={'edit'}
          defaultValues={defaultValue}
        />
      ) : null}

      {open && (type === 'Vehicle' || type === 'Driver') && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'edit'}
          type={`${type} ${iconType}`}
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName={type.toLocaleLowerCase()}
          vehicleId={iconId}
          driverId={iconId}
        />
      )}
    </div>
  );
}

export default ViewVendor;
